import React from "react";

export const CUSTOMERS_PAGE_TITLE = "Customer Projects";

export const customerTableColumns = [
  {
    key: "name",
    header: "Name",
    wrap: true,
    render: (row) => (
      <>
        <div><strong>{row.first_name} {row.last_name}</strong></div>
        <div style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>{row.email}</div>
      </>
    ),
  },
  {
    key: "location",
    header: "Location",
    hideBelow: "xl",
    width: "180px",
    render: (row) => `${row.address?.city ?? ""}, ${row.address?.state ?? ""}`,
  },
];
